import React, { useState, useEffect, useRef } from "react";
import { Container, Row, Col, Form, Button, Modal } from "react-bootstrap";
import { useHistory, useParams } from "react-router-dom";
import UserService from "../../services/user.service";
import Select from "react-select";
import ToastBlockContainer from "../../common/ToastBlockContainer";
import Loading from "../../common/Loading";
import imageX from "../../assets/images/x.svg";
import "react-date-picker/dist/DatePicker.css"; // Import styles
import "react-calendar/dist/Calendar.css"; // Required for calendar display
import { customStyles, customStylesError } from "../../common/CustomStyles";

const SavingsAdd = (props) => {
  let history = useHistory();
  const myRef = useRef(null);
  let { uuid, userUUID } = useParams();
  const [familyDetails, setFamilyDetails] = useState([]);
  const [userCreateUpdate, setUserCreateUpdate] = useState();
  const [subscriptionsUrl, setSubscriptionsUrl] = useState("");
  const [successToast, setSuccessToast] = useState(false);
  const [Loadingdata, setLoadingdata] = useState(true);
  const [otherModal, setOtherModal] = useState(false);
  const [otherType, setOtherType] = useState("");
  const [familyUserId, setFamilyUserId] = useState();
  const [haveAccessView, setHaveAccessView] = useState(false);
  const [haveAccessAdd, setHaveAccessAdd] = useState(false);
  var UserDetails = JSON.parse(localStorage.getItem("UserDetails"));

  const initialValues = {
    supplier: "",
    category: "",
    subcategories: "",
    otherCategory: "",
    otherSubCategory: "",
    otherSupplierName: "",
    amount: "",
    accountNumber: "",
    accountDetails: "",
  };
  const [formValues, setFormValues] = useState(initialValues);
  const [formErrors, setFormErrors] = useState({});
  const [selectedCategory, setSelectedCategory] = useState();
  const [selectedSubCat, setSelectedSubCat] = useState();
  const [selectedSupplier, setSelectedSupplier] = useState();
  const [selectedBalance, setSelectedBalance] = useState();
  const [isSubmit, setIsSubmit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [otherCat, setOtherCat] = useState("");
  const [otherSubCat, setOtherSubCat] = useState("");
  const [otherSupplier, setOtherSupplier] = useState("");

  const [CategoryData, setCategoryData] = useState([]);
  const [alldata, setAlldata] = useState();

  const initialCategoryOption = [{ label: "Select a category", value: "" }];
  const [CategoryOption, setCategoryOption] = useState(initialCategoryOption); // category option

  const initialSubCatOption = [{ label: "Select an Account Type", value: "" }];
  const [subcatOption, setSubcatOption] = useState(initialSubCatOption); // subcategory option

  const initialSupplierOption = [{ label: "Select a Provider", value: "" }];
  const [supplierOption, setSupplierOption] = useState(initialSupplierOption); // supplier option
  const initialBalance = [
    { value: "£1 - £100​", label: "£1 - £100​" },
    { value: "£100 - £1,000", label: "£100 - £1,000" },
    { value: "£1,000 - £10,000", label: "£1,000 - £10,000" },
    { value: "£10,000+", label: "£10,000+" },
    { value: "​​Prefer Not to Say", label: "​​​Prefer Not to Say" },
  ];
  const [balanceAmount, setBalanceAmount] = useState(initialBalance);

  const handleChange = (e, action) => {
    let targetData;
    // Handle action (e.g., for supplier selection)
    if (action) {
      targetData = {
        name: action.name,
        value: e.value,
      };
      if (action.name === "category") {
        if (e.label === "Others") {
          setOtherType("Category");
          setOtherModal(true); // Open the modal
        }
        setSelectedCategory(e);
        // find the supplier related to category
        const result = CategoryData.find((product) => product.id === e.value);

        const supData = result.subcategories.map((val) => ({
          value: val.id,
          label: val.name,
        }));
        const updatedArr = [
          ...supData,
          {
            value: alldata.otherCatndSuppliersData[0].subcategory_id,
            label: alldata.otherCatndSuppliersData[0].subcategory_name,
          },
        ];
        const sortedData =
          e.label === "Others"
            ? [...supData].sort((a, b) => a.label.localeCompare(b.label))
            : [...updatedArr].sort((a, b) => a.label.localeCompare(b.label)); // sort subcat array based on a-z
        setSubcatOption(sortedData);
        setOtherSubCat("");
        setOtherSupplier("");
        setSelectedSubCat(initialSubCatOption);
        setSupplierOption();
        setSelectedSupplier(initialSupplierOption);
        setFormValues((prevValues) => ({
          ...prevValues,
          supplier: "",
          subcategories: "",
        }));
      }

      if (action.name === "subcategories") {
        if (e.label === "Others") {
          setOtherType("Subcategory");
          setOtherModal(true); // Open the modal
        }

        setSelectedSubCat(e);

        const result = CategoryData.find((product) =>
          product.subcategories.find((val) => val.id === e.value)
        );

        const result1 = result.subcategories.find((val) => val.id === e.value);

        const supData = result1.suppliers.map((val) => ({
          value: val.id,
          label: val.name,
        }));
        const updatedArr = [
          ...supData,
          {
            value: alldata.otherCatndSuppliersData[0].supplier_id,
            label: alldata.otherCatndSuppliersData[0].subcategory_name,
          },
        ];

        const sortedData =
          e.label === "Others"
            ? [...supData].sort((a, b) => a.label.localeCompare(b.label))
            : [...updatedArr].sort((a, b) => a.label.localeCompare(b.label)); // sort supplier array based on a-z
        setSupplierOption(sortedData);
        setSelectedSupplier(initialSupplierOption);
        setOtherSupplier("");
        setFormValues((prevValues) => ({
          ...prevValues,
          supplier: "",
        }));
      }

      if (action.name === "supplier") {
        if (e.label === "Others") {
          setOtherType("Supplier");
          setOtherModal(true); // Open the modal
        }
        setSelectedSupplier(e); // Set selected supplier
        setFormErrors((prevErrors) => ({ ...prevErrors, supplier: "" })); // Clear form errors
      }

      if (action.name === "amount") {
        setSelectedBalance(e);
        setFormErrors((prevErrors) => ({ ...prevErrors, frequency: "" }));
      }
    }
    // General case
    else {
      targetData = {
        name: e.target.name,
        value: e.target.value,
      };
    }

    const { name, value } = targetData;
    setFormValues((prevValues) => ({ ...prevValues, [name]: value }));
  };

  // Reset dropdown when modal closes
  const handleCloseModal = () => {
    setOtherModal(false); // Close the modal
    setSelectedSupplier(initialSupplierOption); // Reset the selected supplier

    if (otherType === "Category") {
      setSelectedCategory(initialCategoryOption);
      setSelectedSubCat(initialSubCatOption);
      setSubcatOption(initialSubCatOption);
      setSupplierOption(initialSupplierOption);

      setFormValues((prevValues) => ({
        ...prevValues,
        category: "",
        otherCategory: "",
      }));
    } else if (otherType === "Subcategory") {
      setSelectedSubCat(initialSubCatOption);
      setSupplierOption(initialSupplierOption);
      setFormValues((prevValues) => ({
        ...prevValues,
        subcategories: "",
        otherSubCategory: "",
      }));
    } else {
      setFormValues((prevValues) => ({
        ...prevValues,
        supplier: "",
        otherSupplierName: "",
      }));
    }
    setOtherSupErr("");
  };

  const [otherSupErr, setOtherSupErr] = useState("");

  const submitModal = () => {
    // Check if the input field is empty
    if (
      !formValues.otherSupplierName &&
      !formValues.otherCategory &&
      !formValues.otherSubCategory
    ) {
      setOtherSupErr("otherSupErr");
      return; // Do not proceed if the input field is empty
    }
    setOtherSupErr("");
    console.log(otherType);
    otherType === "Category" && setOtherCat(formValues.otherCategory);
    otherType === "Subcategory" && setOtherSubCat(formValues.otherSubCategory);
    otherType === "Supplier" && setOtherSupplier(formValues.otherSupplierName);
    // setSelectedSupplier(initialSupplierOption); // Reset the selected supplier
    setTimeout(() => {
      setOtherModal(false); // Close the modal
    }, 100);
  };

  // end
  const handleSubmit = (e) => {
    e.preventDefault();

    // Validate the form and get the errors immediately
    const errors = validate(formValues);

    // Update the form errors state
    setFormErrors(errors);

    // Set other states
    setIsSubmit(true);
    setLoading(true);

    // Log errors immediately after validation

    // Call your submit handler
    submitBtn(Object.keys(errors).length);
  };
  const validate = (values) => {
    const errors = {};
    if (!values.category) {
      errors.msg = "Please select the category";
      errors.category = "Yes";
    }
    if (!values.subcategories) {
      errors.msg = "Please select the subcategories";
      errors.subcategories = "Yes";
    }
    if (!values.supplier) {
      errors.msg = "Please select the supplier";
      errors.supplier = "Yes";
    }
    if (!values.amount) {
      errors.msg = "Please enter the amount";
      errors.amount = "Yes";
    }
    return errors;
  };

  useEffect(() => {
    if (isSubmit) {
      const errors = validate(formValues);
      setFormErrors(errors);
    }
  }, [formValues, isSubmit]);

  const getFamilyDetails = (userId) => {
    // AU Family details
    UserService.getUserSingleFamilyDetails(uuid, userId).then(
      (response) => {
        setFamilyDetails(response);
        getRelationData(response);

        // SU Family details
        UserService.getUserSingleFamilyDetails(uuid, UserDetails.id).then(
          (response) => {
            setUserCreateUpdate(response.FamilyData.UserId);
          },
          (error) => {}
        );
      },
      (error) => {}
    );
  };

  const getAUFamilyDetails = (userId) => {
    UserService.getUserSingleFamilyDetails(uuid, userId).then(
      (response) => {
        setFamilyDetails(response);
        getRelationData(response);
        setUserCreateUpdate(response.FamilyData.UserId);
      },
      (error) => {}
    );
  };

  useEffect(() => {
    // get family details
    if (userUUID) {
      UserService.userProfile(userUUID).then((response) => {
        getFamilyDetails(response.userData.id);
        setSubscriptionsUrl("/user_savings/" + uuid + "/" + userUUID);
      });
    } else {
      getAUFamilyDetails(UserDetails.id);
      setSubscriptionsUrl("/savings/" + uuid);
    }
    // get supplier data
    UserService.getCatbyMod(6).then((resp) => {
      setAlldata(resp.data);
      setCategoryData(resp.data.data);
      const selectedData = resp.data.data.map((item) => ({
        value: item.id,
        label: item.name,
      }));
      const sortedData = [...selectedData].sort((a, b) =>
        a.label.localeCompare(b.label)
      ); // sort cat array based on a-z
      setCategoryOption(sortedData);
    });
  }, []);

  const getRelationData = (data) => {
    let payLoad = {
      FamilyId: data.FamilyData.Family.id,
      FamilyUserId: data.FamilyData.id,
    };
    UserService.relationData(uuid).then((respo) => {
      // main user checking
      const mainUser = respo.data.au.find(
        (obj) => obj.User.email === UserDetails.email
      );

      const mainArr = [];
      if (mainUser) {
        mainArr.push(mainUser);
      }

      // support user checking
      const suppUser = respo.data.au.find((obj) =>
        obj.su.find(
          (family) =>
            family.Family_User &&
            family.Family_User.User.email === UserDetails.email
        )
      );

      const suppArr = [];
      if (suppUser) {
        suppArr.push(suppUser);
      }

      let newArray = [];
      newArray = [...mainArr, ...suppArr];
      console.log(mainArr);
      console.log(suppArr);
      console.log(newArray);
      const uuidFind = newArray.find((obj) => obj.User.uuid === userUUID);
      userUUID && setFamilyUserId(uuidFind.id);
      console.log(userUUID);
      UserService.savingsAuthUsers(payLoad).then((respo) => {
        console.log(respo.viewableData);
        var res = respo.viewableData[0];
        if (userUUID === undefined) {
          debugger;
          setHaveAccessAdd(true);
          setHaveAccessView(true);
        } else {
          debugger;
          // console.log(element);
          const newEl = newArray[0].su.find(
            (element) => element.Family_User.User.email === UserDetails.email
          );
          console.log(newEl);
          //
          // { value: "any_one", label: "Anyone" },
          // { value: "el_staff", label: "Only EL staff" },
          // { value: "all_su", label: "Only your Support Users" },
          // { value: "selected_su", label: "Selected Support Users" },
          // { value: "no_one", label: "No one except me" },
          if (
            res.addPrevilege === "any_one" ||
            res.addPrevilege === "all_su" ||
            (res.addableUsers.includes(newEl.FamilyUserId) &&
              !res.viewableUsers.includes(newEl.FamilyUserId))
          ) {
            debugger;
            setHaveAccessAdd(true);
          }
          if (
            res.viewPrevilege === "any_one" ||
            res.viewPrevilege === "all_su" ||
            (res.addableUsers.includes(newEl.FamilyUserId) &&
              !res.viewableUsers.includes(newEl.FamilyUserId)) ||
            res.viewableUsers.includes(newEl.FamilyUserId)
          ) {
            debugger;
            setHaveAccessView(true);
          }
          if (
            res.addPrevilege === "el_staff" ||
            res.addPrevilege === "no_one"
          ) {
            debugger;
            setHaveAccessAdd(false);
          }
          if (
            res.viewPrevilege === "el_staff" ||
            res.viewPrevilege === "no_one"
          ) {
            debugger;
            setHaveAccessView(false);
          }
        }

        setTimeout(() => {
          setLoadingdata(false);
        }, 1000);
      });
    });
  };

  const submitBtn = (length) => {
    // add subscription
    if (length === 0) {
      setLoading(true);
      // convert current time in timestamp
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0");
      const day = String(now.getDate()).padStart(2, "0");
      const hours = String(now.getHours()).padStart(2, "0");
      const minutes = String(now.getMinutes()).padStart(2, "0");
      const seconds = String(now.getSeconds()).padStart(2, "0");
      let data = {
        CategoryId: formValues.category,
        SubCategoryId: formValues.subcategories,
        SupplierId: formValues.supplier,
        name: `${familyDetails.FamilyData.FamilyId}_${
          userUUID ? familyUserId : familyDetails.FamilyData.id
        }_${year}${month}${day}${hours}${minutes}${seconds}`,
        otherSupplierName: formValues.otherSupplierName,
        otherCategory: formValues.otherCategory,
        otherSubCategory: formValues.otherSubCategory,
        Amount: formValues.amount,
        accountNumber: Buffer.from(formValues.accountNumber, "utf8").toString(
          "hex"
        ),
        accountDetails: formValues.accountDetails,
        status: "Active",
        updatedBy: userCreateUpdate,
        FamilyId: familyDetails.FamilyData.FamilyId,
        FamilyUserId: userUUID ? familyUserId : familyDetails.FamilyData.id,
        createdBy: userCreateUpdate,
        logged_in: userUUID ? familyUserId : familyDetails.FamilyData.id,
      };
      // // api call
      UserService.createSavings(data).then(
        (response) => {
          if (response) {
            setLoading(false);
            setSuccessToast(true);
            setShowToast(true);
            // executeScroll();
            window.scrollTo(0, 0);
            setToastMessage("Account created successfully");
            setTimeout(() => {
              history.push(subscriptionsUrl);
            }, 2000);
          } else {
            setLoading(false);
            setSuccessToast(false);
            setShowToast(true);
            window.scrollTo(0, 0);
            setToastMessage("Error !");
          }
        },
        (error) => {}
      );
    } else {
      setLoading(false);
      // window.scrollTo(0, 0);
    }
  };
  console.log(formValues);
  return (
    <Container ref={myRef}>
      <ToastBlockContainer
        successToast={successToast}
        showToast={showToast}
        setShowToast={setShowToast}
        toastMessage={toastMessage}
      />
      {Loadingdata ? (
        <>
          <div className="d-flex" style={{ minHeight: "calc(100vh - 17rem)" }}>
            <Loading />
          </div>
        </>
      ) : (
        <Row className="justify-content-center gy-0 mb-6rem new-datepicker">
          <Col xl="21" xxl="18">
            <h1 className="lh-base mb-4">Add a new account</h1>
            <section className="bg-white p-4 p-md-6 p-lg-8 shadow rounded-4">
              {haveAccessAdd ? (
                <Form onSubmit={handleSubmit} encType="multipart/form-data">
                  <section>
                    <h2 className="mb-1 mb-md-2">Details</h2>
                    <p className="mb-4">
                      Add your accounts here – a simple way to keep track of
                      where your money is stored. This is just for you, so you
                      always remember your accounts
                    </p>

                    <Row className="gy-0 mb-4">
                      {
                        <Col md="12" lg="12">
                          <Form.Label
                            className={
                              formErrors.category ? "text-danger" : " "
                            }
                          >
                            Category
                          </Form.Label>
                          {otherCat ? (
                            <div className="form-control d-flex align-items-center gap-3 justify-content-between">
                              {otherCat}{" "}
                              <button
                                className="rounded-circle bg-white border-1 p-1 border-black d-flex align-items-center justify-content-center"
                                type="button"
                                onClick={() => {
                                  setOtherCat("");
                                  setOtherSubCat("");
                                  setOtherSupplier("");
                                  setSelectedCategory(initialCategoryOption);
                                  setSubcatOption(initialSubCatOption);
                                  setSelectedSubCat(initialSubCatOption);
                                  setSelectedSupplier(initialSupplierOption);
                                  setSupplierOption(initialSupplierOption);
                                  setFormValues((prevValues) => ({
                                    ...prevValues,
                                    otherCategory: "",
                                    category: "",
                                    otherSubCategory: "",
                                    subcategories: "",
                                    otherSupplierName: "",
                                    supplier: "",
                                  }));
                                }}
                              >
                                <img
                                  src={imageX}
                                  alt=""
                                  style={{ width: "16px", height: "16px" }}
                                />
                              </button>
                            </div>
                          ) : (
                            <Select
                              styles={
                                formErrors.category
                                  ? customStylesError
                                  : customStyles
                              }
                              options={CategoryOption}
                              defaultValue={{
                                label: "Select a category",
                                value: "",
                              }}
                              value={selectedCategory}
                              onChange={handleChange}
                              name="category"
                            />
                          )}
                          <Form.Text
                            className={
                              formErrors.category ? "text-danger" : " "
                            }
                          >
                            Select the correct category for this account to see
                            relevant sub-categories and suppliers
                          </Form.Text>
                        </Col>
                      }
                    </Row>
                    <Row className="gy-0 mb-4">
                      {
                        <Col md="12" lg="12">
                          <Form.Label
                            className={
                              formErrors.subcategories ? "text-danger" : " "
                            }
                          >
                            Account Type
                          </Form.Label>

                          {otherSubCat ? (
                            <div className="form-control d-flex align-items-center gap-3 justify-content-between">
                              {otherSubCat}{" "}
                              <button
                                className="rounded-circle bg-white border-1 p-1 border-black d-flex align-items-center justify-content-center"
                                type="button"
                                onClick={() => {
                                  setOtherSubCat("");
                                  setOtherSupplier("");
                                  setSelectedSubCat(initialSubCatOption);
                                  setSelectedSupplier(initialSupplierOption);
                                  setSupplierOption(initialSupplierOption);
                                  setFormValues((prevValues) => ({
                                    ...prevValues,
                                    otherSubCategory: "",
                                    subcategories: "",
                                    otherSupplierName: "",
                                    supplier: "",
                                  }));
                                }}
                              >
                                <img
                                  src={imageX}
                                  alt=""
                                  style={{ width: "16px", height: "16px" }}
                                />
                              </button>
                            </div>
                          ) : (
                            <Select
                              styles={
                                formErrors.subcategories
                                  ? customStylesError
                                  : customStyles
                              }
                              options={subcatOption}
                              defaultValue={{
                                label: "Select an account type",
                                value: "",
                              }}
                              value={selectedSubCat}
                              onChange={handleChange}
                              name="subcategories"
                            />
                          )}
                          <Form.Text
                            className={
                              formErrors.subcategories ? "text-danger" : " "
                            }
                          >
                            Now, select the specific type for this account. For
                            example, if you selected 'Insurance,' you might
                            choose 'Car', 'Van', or 'Home' insurance.
                          </Form.Text>
                        </Col>
                      }
                    </Row>
                    <Row className="gy-0 mb-4">
                      {
                        <Col md="12" lg="12">
                          <Form.Label
                            className={
                              formErrors.supplier ? "text-danger" : " "
                            }
                          >
                            Provider
                          </Form.Label>
                          {otherSupplier ? (
                            <div className="form-control d-flex align-items-center gap-3 justify-content-between">
                              {otherSupplier}{" "}
                              <button
                                className="rounded-circle bg-white border-1 p-1 border-black d-flex align-items-center justify-content-center"
                                type="button"
                                onClick={() => {
                                  setOtherSupplier("");
                                  setFormValues((prevValues) => ({
                                    ...prevValues,
                                    otherSupplierName: "",
                                  }));
                                }}
                              >
                                <img
                                  src={imageX}
                                  alt=""
                                  style={{ width: "16px", height: "16px" }}
                                />
                              </button>
                            </div>
                          ) : (
                            <Select
                              styles={
                                formErrors.supplier
                                  ? customStylesError
                                  : customStyles
                              }
                              options={supplierOption}
                              defaultValue={{
                                label: "Select a provider",
                                value: "",
                              }}
                              value={selectedSupplier}
                              onChange={handleChange}
                              name="supplier"
                            />
                          )}
                          <Form.Text
                            className={
                              formErrors.supplier ? "text-danger" : " "
                            }
                          >
                            Select the company or provider for this account. If
                            you can’t find your supplier, simply choose 'Other'
                            to enter it manually
                          </Form.Text>
                        </Col>
                      }
                    </Row>
                  </section>
                  <hr className="my-6 my-md-7" />
                  <section>
                    <h3 className="mb-1 mb-md-2">Amount</h3>
                    <p className="mb-4">Add details of your account</p>
                    <Row className="gy-0 mb-4">
                      <Col xs="18" sm="14" md="12" lg="8">
                        <Form.Label
                          className={formErrors.amount ? "invalid-text" : ""}
                        >
                          Balance
                        </Form.Label>
                        <Select
                          styles={
                            formErrors.amount ? customStylesError : customStyles
                          }
                          options={balanceAmount}
                          defaultValue={{
                            label: "Balance Range",
                            value: "",
                          }}
                          value={selectedBalance}
                          onChange={handleChange}
                          name="amount"
                        />
                        <Form.Text
                          className={formErrors.amount ? "text-danger" : " "}
                        >
                          Please enter the balance
                        </Form.Text>
                      </Col>
                    </Row>
                    <Row className="gy-0 mb-4">
                      <Col xs="18" sm="14" md="12" lg="8">
                        <Form.Label
                          className={
                            formErrors.accountNumber ? "invalid-text" : ""
                          }
                        >
                          Account number
                        </Form.Label>
                        <Form.Control
                          className={
                            formErrors.accountNumber
                              ? "is-invalid invalid-border-right"
                              : ""
                          }
                          type="text"
                          name="accountNumber"
                          placeholder="e.g., 1234 5678 9012​"
                          value={formValues.accountNumber}
                          onChange={handleChange}
                        />
                        <Form.Text>Provide account number</Form.Text>
                      </Col>
                    </Row>
                    <Row className="gy-0 mb-4">
                      <Col xs="24">
                        <Form.Label
                          className={
                            formErrors.accountDetails ? "invalid-text" : ""
                          }
                        >
                          Account details
                        </Form.Label>
                        <Form.Control
                          className={
                            formErrors.accountDetails
                              ? "is-invalid invalid-border-right"
                              : ""
                          }
                          as="textarea"
                          rows={5}
                          cols={1}
                          name="accountDetails"
                          placeholder="Add any extra details or special notes here​"
                          value={formValues.accountDetails}
                          onChange={handleChange}
                          maxLength={255}
                        />
                        <Form.Text>Provide account details</Form.Text>
                      </Col>
                    </Row>
                  </section>
                  <hr className="my-6 my-md-7" />

                  <div className="d-flex justify-content-end">
                    <Button
                      className="d-flex align-items-center"
                      variant="primary"
                      type="submit"
                      isLoading={loading ? "true" : "false"}
                      isDisabled={loading ? "true" : "false"}
                    >
                      <i className="fa-solid fa-sm fa-add lh-1 align-middle me-2"></i>
                      Add account
                    </Button>
                  </div>
                </Form>
              ) : (
                <div
                  className=" d-flex align-items-center justify-content-center"
                  style={{ height: "20rem" }}
                >
                  You have no access to view this page. Please check with the
                  Main User for the access
                </div>
              )}
            </section>
          </Col>
        </Row>
      )}

      {/* uploaded document   */}
      <Modal show={otherModal} onHide={() => handleCloseModal()} className="">
        <Modal.Header closeButton>
          <Modal.Title className="mx-1">
            <h3 className="mb-0">
              Add other{" "}
              {otherType === "Category"
                ? otherType.charAt(0).toLowerCase() + otherType.slice(1)
                : otherType === "Subcategory"
                ? "account type"
                : "provider"}{" "}
              name
            </h3>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-5">
            <Form.Label className={otherSupErr ? "text-danger" : ""}>
              {otherType === "Category"
                ? otherType
                : otherType === "Subcategory"
                ? "Account type"
                : "Provider"}{" "}
              name
            </Form.Label>
            <Form.Control
              className={`mb-2 ${
                otherSupErr ? "is-invalid invalid-border-right" : ""
              }`}
              type="text"
              maxlength="100"
              placeholder="e.g. Starbucks"
              name={
                otherType === "Category"
                  ? "otherCategory"
                  : otherType === "Subcategory"
                  ? "otherSubCategory"
                  : "otherSupplierName"
              }
              value={
                otherType === "Category"
                  ? formValues.otherCategory
                  : otherType === "Subcategory"
                  ? formValues.otherSubCategory
                  : formValues.otherSupplierName
              }
              onChange={handleChange}
            />
            <Form.Text className={otherSupErr ? "text-danger mb-4" : "mb-4"}>
              Please enter the name of the{" "}
              {otherType === "Category"
                ? otherType.charAt(0).toLowerCase() + otherType.slice(1)
                : otherType === "Subcategory"
                ? "account type"
                : "provider"}{" "}
              if you haven't found their name in the dropdown
            </Form.Text>
          </div>
          <button
            className="btn btn-primary"
            type="button"
            onClick={() => submitModal()}
          >
            + Add
          </button>
        </Modal.Body>
      </Modal>
    </Container>
  );
};
export default SavingsAdd;
